export default __webpack_public_path__ + "static/heart4-6e0b0c4569b39eec63c3e0cbb99f02cd.webp";